import axiosInstance from "./axios-instance";
import { isMutationSuccess } from "./cache-utils";
import { invalidateOrderDataCache, resolveClientId, resolveOrderId } from "./cache-invalidation";

const getScopedAccountId = (accountId?: number): number => {
    if (typeof window === "undefined") {
        return Number(accountId || 0);
    }
    const ownerAccountId = Number(localStorage.getItem("ownerAccountId") || "0");
    if (ownerAccountId > 0) {
        return ownerAccountId;
    }
    if (Number(accountId) > 0) {
        return Number(accountId);
    }
    return Number(localStorage.getItem("accountId") || "0");
};

const withScopedAccountId = (payload: any) => {
    if (!payload || typeof payload !== "object") {
        return payload;
    }
    const scopedAccountId = getScopedAccountId(payload.accountId);
    if (!(scopedAccountId > 0)) {
        return payload;
    }
    return {
        ...payload,
        accountId: scopedAccountId,
    };
};

const addDraperyOrderSummary = async (payload: any) => {
    try {
        const response = await axiosInstance.post<any>(
            "/draperyOrderSummary/add",
            withScopedAccountId(payload)
        );
        if (isMutationSuccess(response.data)) {
            invalidateOrderDataCache(resolveOrderId(payload, response.data), resolveClientId(payload, response.data));
        }
        return response.data;
    } catch (error) {
        console.error("Error add drapery order summary:", error);
        throw error;
    }
};
const editDraperyOrderSummary = async (payload: any) => {
    try {
        const response = await axiosInstance.put<any>(
            "/draperyOrderSummary/edit",
            withScopedAccountId(payload)
        );
        if (isMutationSuccess(response.data)) {
            invalidateOrderDataCache(resolveOrderId(payload, response.data), resolveClientId(payload, response.data));
        }
        return response.data;
    } catch (error) {
        console.error("Error edit drapery order summary:", error);
        throw error;
    }
};
export { addDraperyOrderSummary, editDraperyOrderSummary };
